// extracted by mini-css-extract-plugin
export default {"sceneContainer":"BackgroundScene_sceneContainer__3EbZP","canvas":"BackgroundScene_canvas__maJBu","interactiveScene":"BackgroundScene_interactiveScene__o+0ZZ"};